import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card/Card";
import dados from "../data/projetosGerais.json";

function Video360() {
  const navigate = useNavigate();
  const projetosVideo360 = dados.filter((p) => p.tags.includes("Vídeo 360"));

  // abre a página de detalhes do projeto
  const handleCardClick = (id) => {
    navigate(`/projeto/${id}`);
  };

  return (
    <div className="pagina-categoria">
      <h1>Projetos com vídeos em 360</h1>
      <div className="cards-container">
        {projetosVideo360.map((projeto) => (
          <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
        ))}
      </div>
    </div>
  );
}

export default Video360;
